import { Alert } from '@mui/material'

export function DmpConnectError({ error }: { error: unknown }) {
  return (
    <div>
      <Alert severity="error">{error}</Alert>
    </div>
  )
}
